import AddCustomerCard from "../../../../Components/popUpComponents/AddCustomerCard/AddCustomerCard";
import { Card, CardBody, CardHeader, Col, Input, Row } from "reactstrap";
import { isEmpty } from "lodash";
import TableContainer from "../../../../Components/Common/TableContainer";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerCards } from "../../../../store/charges/action";
import HandleDateTime from "../../../../Components/Common/HandleDateTime";

import amex from "../../../../assets/images/creditDebitCards/amex.png";
import anyCard from "../../../../assets/images/creditDebitCards/anyCard.png";
import masterCard from "../../../../assets/images/creditDebitCards/mastercard.png";
import visa from "../../../../assets/images/creditDebitCards/visa.png";
import SettingsPanel from "../../components/SettingsPanel";
export default function CardList() {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const { CustomerCardsList } = useSelector((state) => ({
    CustomerCardsList: state.Charges.customerCardsList?.masterpaymentcard_list,
  }));
  // Stripe Starts Here
  useEffect(() => {
    dispatch(getCustomerCards());
  }, []);

  const handleHelperShowCard = (brandName) => {
    let useCard;
    switch (brandName) {
      case "visa":
        useCard = visa;
        break;
      case "masterCard":
        useCard = masterCard;
        break;
      case "American Express":
        useCard = amex;
        break;
      default:
        useCard = anyCard;
        break;
    }

    return (
      <div>
        {/*  useCard to display small image for the card*/}
        <img src={useCard} alt="card" width="35" height="100%" />
      </div>
    );
  };

  const columns = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "Id",
        filterable: false,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                <span className={"like-href"}> #{card.row.original.Id}</span>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Brand",
        accessor: "Brand",
        filterable: true,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                {handleHelperShowCard(card.row.original?.Brand)}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Last 4 Digits",
        accessor: "Last4Digits",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        Cell: (card) => {
          return (
            <div>
              <span className={""}>{card.row.original?.Last4Digits}</span>
              {card.row.original?.FlagPrimary === "1" && (
                <span className={"ms-2 badge badge-soft-success"}>Primary</span>
              )}
            </div>
          );
        },
        filterable: false,
      },
      {
        Header: "Expiry Date",
        accessor: "ExpiryYear",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        Cell: (card) => {
          return (
            <div>
              <span className={""}>
                {+card.row.original?.ExpiryMonth > 9
                  ? card.row.original?.ExpiryMonth
                  : "0" + card.row.original?.ExpiryMonth}{" "}
                / {card.row.original?.ExpiryYear}{" "}
              </span>
            </div>
          );
        },
        filterable: false,
      },

      {
        Header: "Created Date",
        accessor: (row) => {
          //CreatedDateTime sort date so its day Month name Year and time

          return <div>{HandleDateTime(row.CreatedDateTime)}</div>;

          // return row.CreatedDateTime
        },
        filterable: true,
      },
    ],
    []
  );
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "Last4Digits",
    "Id",
    "UpdatedDateTime",
    "ExternalRef",
    "CreatedDateTime",
    "Brand",
  ]);
  useEffect(() => {
    let filteredCustomerList = CustomerCardsList;

    const timer = setTimeout(() => {
      filteredCustomerList = filteredCustomerList?.filter((item) => {
        return allowedSearchFilters.some((key) => {
          return (
            item[key] &&
            item[key].toString().toLowerCase().includes(search?.toLowerCase())
          );
        });
      });

      setSearchResults(filteredCustomerList);
    }, 300);
    return () => clearTimeout(timer);
  }, [search, CustomerCardsList]);

  const [modalAddCustomerCard, setModalAddCustomerCard] = useState(false);
  const toggleAddCustomerCard = () =>
    setModalAddCustomerCard(!modalAddCustomerCard);

  return (
    <SettingsPanel
      title="Card List"
      description="Payment cards saved for this company"
    >
      <Row>
        {modalAddCustomerCard && (
          <AddCustomerCard
            modalAddCustomerCard={modalAddCustomerCard}
            setModalAddCustomerCard={setModalAddCustomerCard}
            toggleAddCustomerCard={toggleAddCustomerCard}
          />
        )}

        <Col lg={12}>
          <Card id="customersList">
            <CardHeader className="border-0">
              <Row className="g-4 align-items-center">
                <Col sm={3}>
                  <div className="search-box">
                    <Input
                      // create search with jobs List Data
                      type="search"
                      className="form-control search"
                      placeholder="Search for..."
                      onChange={setSearch}
                      value={search}
                    />
                    <i className="ri-search-line search-icon"></i>
                  </div>
                </Col>
                <div className="col-sm-auto ms-auto">
                  <div className="hstack gap-2">
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        setModalAddCustomerCard(true);
                      }}
                    >
                      <i className="ri-add-line align-bottom me-1"></i>
                      Add new Card
                    </button>
                  </div>
                </div>
              </Row>
            </CardHeader>
            <CardBody className="pt-0">
              <div>
                {!isEmpty(CustomerCardsList) ? (
                  <TableContainer
                    columns={columns}
                    data={searchResults || []}
                    isGlobalFilter={false}
                    isAddUserList={false}
                    customPageSize={10}
                    className="custom-header-css"
                    divClass="table-responsive table-card mb-0"
                    tableClass="align-middle table-nowrap"
                    theadClass="text-muted"
                    // handleLeadClick={handleLeadClicks}
                    isLeadsFilter={false}
                  />
                ) : (
                  <div>No Cards Found</div>
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </SettingsPanel>
  );
}
